<script setup lang="ts">
import type { BlokDefinitionList } from "@/.storyblok/types/120421/storyblok-components";
import { backgroundColorInjectKey } from "../helpers/injectKeys";

defineProps<{
    blok: BlokDefinitionList;
}>();

const injectedBackgroundColor = inject(backgroundColorInjectKey) as BackgroundColorKey;
</script>

<template>
    <dl v-editable="blok" class="grid gap-4 md:grid-cols-[1fr,1fr]">
        <BlokDefinitionListEntry :blok="entry" v-for="entry in blok.definitions" :key="entry._uid" />
    </dl>
</template>